import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { FacadeSesionService } from 'src/app/services/facade-sesion.service';

@Component({
  selector: 'lista-direcciones',
  templateUrl: './lista-direcciones.component.html',
  styleUrls: ['./lista-direcciones.component.scss'],
  animations: [
    // the fade-in/fade-out animation.
    trigger('fadeIn', [

      // the "in" style determines the "resting" state of the element when it is visible.
      state('in', style({ opacity: 1 })),

      // fade in when created. this could also be written as transition('void => *')
      transition(':enter', [
        style({ opacity: 0 }),
        animate(300)
      ]),

      // fade out when destroyed. this could also be written as transition('void => *')
      transition(':leave',
        animate(300, style({ opacity: 0 })))
    ])
  ]
})
export class ListaDireccionesComponent implements OnInit {
  constructor(
    private router: Router,
    private facadeSesionService:FacadeSesionService
  ) { }

  ngOnInit() {
    this.facadeSesionService.interfazService.inicializar();
  }

  public seleccionarDireccion(direccion: string): void {
    this.facadeSesionService.breadcrumbService.actualizarBreadcrumbDireccion(direccion);
    this.router.navigate(['/seleccion-modulos/lista-modulos-principales'], { skipLocationChange: true });
  }


}
